import React, {ReactElement} from "react"

const BookmarkIcon = (): ReactElement =>
	<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.16699 5.5C1.16699 4.09987 1.16699 3.3998 1.43948 2.86502C1.67916 2.39462 2.06161 2.01217 2.53202 1.77248C3.0668 1.5 3.76686 1.5 5.16699 1.5H8.83366C10.2338 1.5 10.9339 1.5 11.4686 1.77248C11.939 2.01217 12.3215 2.39462 12.5612 2.86502C12.8337 3.3998 12.8337 4.09987 12.8337 5.5V16.5L7.00033 13.1667L1.16699 16.5V5.5Z"
			fill="#0960A3" stroke="#0960A3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>

export default BookmarkIcon
